import React from "react";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";

const SeriesPageSummaryComponent = ({ strCollectionSummery }) => {
  if (!strCollectionSummery) return null;

  return (
    <div styleName="klipit-items">
      <div styleName="summary">
        <p>{strCollectionSummery}</p>
      </div>
    </div>
  );
};

export default SeriesPageSummaryComponent;
